import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import PermissionService from "services/permission.service";
import { IPermissionResponse } from "models/church.types";

export default function PermissionList() {
  const [permissions, setPermissions] = useState<IPermissionResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      setLoading(true);
      const response = await PermissionService.getAll();
      setPermissions(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des permissions :", error);
      toast.error("Erreur réseau lors de la récupération des permissions");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (permission: IPermissionResponse) => {
    if (
      window.confirm(
        `Supprimer définitivement la permission "${permission.name}" ?`,
      )
    ) {
      try {
        await PermissionService.delete(permission.id);
        fetchPermissions();
        toast.success("Permission supprimée avec succès");
      } catch (error) {
        console.error("Erreur lors de la suppression :", error);
        toast.error("Impossible de supprimer cette permission");
      }
    }
  };

  return (
    <div className="flex flex-col justify-start pt-10 w-full min-h-screen px-4">
      <div className="flex flex-col md:flex-row gap-4 mt-20 mb-4 px-4 justify-between items-center">
        <Link
          to="/admin/permissions/register"
          className="bg-[#D4AF37] hover:bg-[#b8952e] text-slate-900 font-bold px-8 h-[38px] flex items-center justify-center rounded-lg whitespace-nowrap transition-colors w-full lg:w-auto text-center text-sm"
        >
          <i className="fas fa-shield-alt mr-2 text-lg"></i> Nouvelle Permission
        </Link>
      </div>

      {/* TABLE CARD */}
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-2xl rounded-2xl bg-slate-800 border border-slate-700 overflow-hidden">
        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr className="bg-[#0F172A]/50 text-slate-300 uppercase text-[10px] font-black tracking-widest border-b border-slate-700">
                <th className="px-6 py-4 text-left">Nom de la Permission</th>
                <th className="px-6 py-4 text-left">Description</th>
                <th className="px-6 py-4 text-center">Créé par</th>
                <th className="px-6 py-4 text-center">Date de création</th>
                <th className="px-6 py-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700/50">
              {loading ? (
                <tr>
                  <td
                    colSpan={5}
                    className="px-6 py-10 text-center text-slate-500 italic"
                  >
                    <i className="fas fa-circle-notch fa-spin mr-2"></i>{" "}
                    Chargement des permissions...
                  </td>
                </tr>
              ) : permissions.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="px-6 py-10 text-center text-slate-500 italic"
                  >
                    Aucune permission configurée.
                  </td>
                </tr>
              ) : (
                permissions.map((permission) => (
                  <tr
                    key={permission.id}
                    className="hover:bg-slate-700/30 transition-colors group"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="w-8 h-8 rounded-lg bg-slate-700 flex items-center justify-center text-[#D4AF37] font-bold mr-3 border border-slate-600">
                          <i className="fas fa-lock text-xs"></i>
                        </div>
                        <span className="text-sm font-bold text-white uppercase tracking-tighter">
                          {permission.name}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-xs text-slate-400 font-medium max-w-xs truncate">
                      {permission.description || "Aucune description"}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="text-[10px] bg-slate-900 text-slate-400 px-2 py-1 rounded border border-slate-700">
                        {permission.createdBy}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center text-xs text-slate-500">
                      {permission.createdDate
                        ? new Date(permission.createdDate).toLocaleDateString()
                        : "-"}
                    </td>
                    <td className="px-6 py-4 text-right">
                      <div className="flex justify-end items-center gap-2">
                        {/* SUPPRIMER */}
                        <button
                          onClick={() => handleDelete(permission)}
                          type="button"
                          className="flex items-center justify-center w-9 h-9 text-slate-400 hover:text-red-500 hover:bg-red-500/10 rounded-xl transition-all"
                          title="Supprimer la permission"
                        >
                          <i className="fas fa-trash-alt text-sm"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
